module.exports = __webpack_public_path__ + "img/dexscreener.322a5a2d.png";